<rav-modal [modalId]="'newUser'" modalTitle="{{ actionType }} User">
  <form (ngSubmit)="createUser(formGroup.value)" [formGroup]="formGroup" novalidate>
    <rav-input [controlFormGroup]="formGroup" controlName="first_name"></rav-input>
    <rav-input [controlFormGroup]="formGroup" controlName="last_name"></rav-input>
    <rav-input [controlFormGroup]="formGroup" controlName="email" [autocomplete]="false"></rav-input>
    <rav-input [controlFormGroup]="formGroup" controlName="phone_number"></rav-input>
    <rav-select
      *ngIf="!isCurrentUser"
      [controlFormGroup]="formGroup"
      controlName="role"
      [selectOptions]="selectOptions"
    ></rav-select>
    <div *ngIf="!displayRole">
      <rav-input [controlFormGroup]="formGroup" controlName="account_id"></rav-input>
    </div>
    <rav-form-messages [formGroup]="formGroup"></rav-form-messages>
    <div *ngIf="isPlanCtaVisible && !isAdmin" class="small warning callout">
      <i class="fa fa-exclamation-triangle"></i> To add more users, upgrade to a Mama Raven plan
      <a routerLink="/account/billing">here</a>
    </div>
    <div *ngIf="isPlanCtaVisible && isAdmin" class="small warning callout">
      <i class="fa fa-exclamation-triangle"></i> The user doesn't have the account type that allows multiple users.
    </div>
    <button type="submit" class="button margin-right-1" [disabled]="formGroup.invalid">{{ actionType }} User</button>
    <button type="button" class="hollow button" (click)="modal.close.next()">Cancel</button>
  </form>
</rav-modal>
<rav-extra-authentication></rav-extra-authentication>
